import { useEffect, useState } from "react";
import { Users } from "lucide-react";

import api from "../../lib/api";
import { Loading } from "../../components/shared";

export default function ResidentMyHousehold() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/resident/household").then((response) => setData(response.data));
  }, []);

  if (!data) return <Loading />;

  return (
    <div data-testid="resident-household-page">
      <p className="text-xs font-semibold uppercase tracking-[0.18em] text-slate-500">My Household</p>
      <h1 className="mt-2 font-display text-4xl font-bold text-slate-900">
        Unit {data.unit.unit_number}
      </h1>
      <div className="mt-8 grid gap-3 sm:grid-cols-2">
        {data.household.length ? data.household.map((member, index) => (
          <article className="border border-slate-200 bg-white p-5" data-testid={`household-member-${index}`} key={`${member.name}-${index}`}>
            <Users className="h-5 w-5 text-primary" />
            <p className="mt-4 font-display text-lg font-semibold text-slate-900">{member.name}</p>
            <p className="mt-1 text-sm text-slate-600">{member.relationship || member.occupant_type}</p>
            {member.is_you && <p className="mt-3 text-xs font-semibold text-emerald-700">You</p>}
          </article>
        )) : (
          <p className="border border-dashed border-slate-300 bg-white p-5 text-sm text-slate-600" data-testid="household-empty-state">
            No household members are recorded for this home.
          </p>
        )}
      </div>
    </div>
  );
}